import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-notify-export-data-customer-dialog',
  templateUrl: './notify-export-data-customer-dialog.component.html',
  styles: ['./notify-export-data-customer-dialog.component.scss']
})
export class NotifyExportDataCustomerComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NotifyExportDataCustomerComponent>,
    private message: Message,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = false;
  }

  ngOnInit() {

  }

  getContent(): string {
    switch(this.data.typeDialog) {
      case 'export_customer_full':
        return this.commonService.format(
          this.message.getMessage('messages.confirm_export_data_customer_full'), this.data.countCustomer);
      case 'export_customer_compact':
        return this.commonService.format(
          this.message.getMessage('messages.confirm_export_data_customer_compact'), this.data.countCustomer);
      case 'export_group_customer_full':
        return this.commonService.format(
          this.message.getMessage('messages.confirm_export_data_group_customer_full'), this.data.groupCustomers.join(', '));
      case 'export_group_customer_compact':
        return this.commonService.format(
          this.message.getMessage('messages.confirm_export_data_group_customer_compact'), this.data.groupCustomers.join(', '));
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  exportData() {
    this.dialogRef.close('export');
  }

  exportDataAndViewResult() {
    this.dialogRef.close('export_and_view');
  }

  tractContent(functionName: string){
    switch(this.data.typeDialog) {
      case 'export_customer_full':
        return 'w.btn.danh_sach_kh.xuat_day_du.'+ functionName
      case 'export_customer_compact':
        return 'w.btn.danh_sach_kh.xuat_rut_gon.'+ functionName
      case 'export_group_customer_full':
        return 'w.btn.dsnhomkh.xuat_day_du.'+ functionName
      case 'export_group_customer_compact':
        return 'w.btn.dsnhomkh.xuat_rut_gon.'+ functionName
    }
  }
}
